module.exports = __webpack_public_path__ + "img/effect_2.a099793a.jpg";